import { apiService } from '../services/api';

export const fetchSponsorBySlug = async (slug: string) => {
  // For now, we'll use the sponsor ID directly since we don't have slug-based lookup
  // This should be updated when we have proper slug support
  return apiService.getSponsorDetails(slug);
};

export const fetchSponsorMentions = async (sponsorId: string) => {
  // This will return the sponsor details which includes episodes with mentions
  const sponsorDetails = await apiService.getSponsorDetails(sponsorId);
  
  // Transform the data to match the expected format
  const mentions = sponsorDetails.episodes.flatMap(episodeData => 
    episodeData.mentions.map(mention => ({
      _id: mention._id,
      startTime: mention.startTime,
      endTime: mention.endTime,
      duration: mention.duration,
      text: mention.text,
      confidence: mention.confidence,
      mentionType: mention.mentionType || 'conversation',
      detectedAt: mention.detectedAt,
      episode: episodeData.episode,
      podcast: episodeData.podcast,
      sponsor: sponsorDetails.sponsor
    }))
  );

  // Calculate stats
  const podcastStats = new Map();
  let totalTimeOnAir = 0;
  let totalViews = 0;
  let totalMentions = mentions.length;

  mentions.forEach(mention => {
    const podcastId = mention.podcast._id;
    if (!podcastStats.has(podcastId)) {
      podcastStats.set(podcastId, {
        _id: podcastId,
        title: mention.podcast.title,
        thumbnail: mention.podcast.imageUrl || mention.podcast.youtubeData?.snippet?.thumbnails?.default?.url,
        mentions: 0,
        timeOnAir: 0,
        views: parseInt(mention.episode.views || '0') || 0,
        episodeCount: 0
      });
    }
    
    const stats = podcastStats.get(podcastId);
    stats.mentions++;
    stats.timeOnAir += mention.duration;
    totalTimeOnAir += mention.duration;
    totalViews += parseInt(mention.episode.views || '0') || 0;
  });

  // Count unique episodes per podcast
  const episodeCounts = new Map();
  mentions.forEach(mention => {
    const podcastId = mention.podcast._id;
    const episodeId = mention.episode._id;
    if (!episodeCounts.has(podcastId)) {
      episodeCounts.set(podcastId, new Set());
    }
    episodeCounts.get(podcastId).add(episodeId);
  });

  // Update episode counts
  episodeCounts.forEach((episodes, podcastId) => {
    if (podcastStats.has(podcastId)) {
      podcastStats.get(podcastId).episodeCount = episodes.size;
    }
  });

  return {
    mentions,
    stats: {
      podcasts: Array.from(podcastStats.values()),
      totals: {
        totalTimeOnAir,
        totalViews,
        totalMentions
      }
    }
  };
}; 